import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Twitter, Linkedin, Instagram } from "lucide-react";

const Footer = () => {
  const navigate = useNavigate();

  const handleServiceClick = (serviceId) => {
    navigate(`/services?service=${serviceId}`);
  };

  return (
    <footer className="bg-gray-50 py-12 sm:py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-12 lg:gap-24 mb-8 sm:mb-12 md:mb-16">
          {/* Brand Section */}
          <div className="lg:col-span-1">
            <div className="text-3xl sm:text-4xl font-bold mb-4 sm:mb-6 md:mb-8">
              <span className="text-gray-900">Post</span>
              <span className="text-blue-500">mint</span>
            </div>
            <p className="text-gray-500 text-base sm:text-lg leading-relaxed mb-6 sm:mb-8 md:mb-10">
              Innovative IT solutions that drive digital success. We help
              businesses transform through technology, design, and strategic
              consulting for sustainable growth.
            </p>
            <div className="flex gap-3 sm:gap-4">
              <div className="w-12 h-12 sm:w-14 sm:h-14 bg-blue-500 rounded-lg flex items-center justify-center text-white cursor-pointer hover:bg-blue-600 transition">
                <Twitter className="w-5 h-5 sm:w-6 sm:h-6" />
              </div>
              <div className="w-12 h-12 sm:w-14 sm:h-14 bg-blue-500 rounded-lg flex items-center justify-center text-white cursor-pointer hover:bg-blue-600 transition">
                <Linkedin className="w-5 h-5 sm:w-6 sm:h-6" />
              </div>
              <div className="w-12 h-12 sm:w-14 sm:h-14 bg-blue-500 rounded-lg flex items-center justify-center text-white cursor-pointer hover:bg-blue-600 transition">
                <Instagram className="w-5 h-5 sm:w-6 sm:h-6" />
              </div>
              <div className="w-12 h-12 sm:w-14 sm:h-14 bg-blue-500 rounded-lg flex items-center justify-center text-white cursor-pointer hover:bg-blue-600 transition">
                <svg
                  className="w-5 h-5 sm:w-6 sm:h-6"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M12 2C6.477 2 2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.879V14.89h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.989C18.343 21.129 22 16.99 22 12c0-5.523-4.477-10-10-10z" />
                </svg>
              </div>
            </div>
          </div>

          {/* Quick Links Section */}
          <div>
            <h3 className="font-bold text-blue-500 text-lg sm:text-xl mb-4 sm:mb-6 md:mb-8">
              Quick Links
            </h3>
            <div className="space-y-3 sm:space-y-4 text-gray-500 text-base sm:text-lg">
              <Link
                to="/"
                className="block hover:text-blue-500 cursor-pointer transition"
              >
                Home
              </Link>
              <Link
                to="/services"
                className="block hover:text-blue-500 cursor-pointer transition"
              >
                Services
              </Link>
              <Link
                to="/"
                className="block hover:text-blue-500 cursor-pointer transition"
              >
                Portfolio
              </Link>
              <Link
                to="/about-us"
                className="block hover:text-blue-500 cursor-pointer transition"
              >
                About
              </Link>
            </div>
          </div>

          {/* Services Section */}
          <div>
            <h3 className="font-bold text-blue-500 text-lg sm:text-xl mb-4 sm:mb-6 md:mb-8">
              Services
            </h3>
            <div className="space-y-3 sm:space-y-4 text-gray-500 text-base sm:text-lg">
              <div
                onClick={() => handleServiceClick(1)}
                className="hover:text-blue-500 cursor-pointer transition"
              >
                Website Design
              </div>
              <div
                onClick={() => handleServiceClick(2)}
                className="hover:text-blue-500 cursor-pointer transition"
              >
                UI/UX Design
              </div>
              <div
                onClick={() => handleServiceClick(3)}
                className="hover:text-blue-500 cursor-pointer transition"
              >
                Digital Solutions
              </div>
              <div
                onClick={() => handleServiceClick(4)}
                className="hover:text-blue-500 cursor-pointer transition"
              >
                Client Support
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-300 pt-6 sm:pt-8 md:pt-10 flex flex-col sm:flex-row justify-between items-center gap-4 sm:gap-0 text-sm sm:text-base text-gray-400">
          <div className="text-center sm:text-left">
            © 2025 Postmint. All rights reserved.
          </div>
          <div className="flex gap-6 sm:gap-10">
            <div className="hover:text-blue-500 cursor-pointer transition">
              Privacy Policy
            </div>
            <div className="hover:text-blue-500 cursor-pointer transition">
              Terms of Service
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
